import { MouseEventHandler, useState } from 'react';
import { useIntl } from 'react-intl';
import { EmptyState } from '@ets/design-system';

import { useSelector } from '_common/hooks';
import Title from './Title/Title';
import Tabs, { TabType } from './Tabs/Tabs';

import styles from './InformationPanel.module.scss';

export type InformationPanelProps = {
  onClose: MouseEventHandler<HTMLSpanElement>;
  testId: string;
};

const InformationPanel = ({ onClose, testId }: InformationPanelProps) => {
  const intl = useIntl();

  const selectedElements = Object.keys(useSelector((state) => state.table.selected));
  const object = useSelector((state) => state.app.data[selectedElements[0]]);

  const [selectedTab, setSelectedTab] = useState<TabType>('general');

  const handleTabSelectionChanged = (selectedTab: TabType) => {
    setSelectedTab(selectedTab);
  };

  return selectedElements.length === 1 && !!object ? (
    <div className={styles.content} data-testid={`${testId}-content`}>
      <Title onClose={onClose} />
      <Tabs selectedTab={selectedTab} onChange={handleTabSelectionChanged} />
    </div>
  ) : (
    <div className={styles.emptyState} data-testid={`${testId}-emptystate`}>
      {selectedElements.length === 0 ? (
        <EmptyState
          size="m"
          title={intl.formatMessage({ id: 'NO_ELEMENTS_SELECTED' })}
          testId="information-panel-no-element-selected"
          description={intl.formatMessage({
            id: 'INFORMATION_SELECT_AN_ELEMENT',
          })}
        />
      ) : (
        <EmptyState
          size="m"
          title={intl.formatMessage({ id: 'MULTIPLE_ELEMENTS_SELECTED' })}
          testId="information-panel-multiple-elements-selected"
          description={intl.formatMessage({
            id: 'INFORMATION_SELECT_A_SINGLE_ELEMENT',
          })}
        />
      )}
    </div>
  );
};

export default InformationPanel;
